/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React, { Fragment } from 'react'
import { RouteComponentProps, Route } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Modal, ModalBody, ModalFooter, FormFeedback, Button, Input, Row, Col, Label, Form, Container, Spinner, FormGroup } from 'reactstrap'
import { injectProperty, container } from '../../arc/configuration/ServiceLocator'
import './CoverageDiscoveryRequest.scss'
import { IUserSessionStateManager } from '../../arc/services/UserSessionStateManager/contracts'
import { ICoverageDiscoveryRequestStateManager } from '../../services/CoverageDiscoveryRequestStateManager/contracts'
import { ICoverageDiscoveryRequestApiClient } from '../../services/CoverageDiscoveryRequestApiClient/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { ValidationMessage, MessageTypes } from '../ValidationMessage/ValidationMessage'
import { TopPart } from '../TopPart/TopPart'
import MaskedInput from 'react-text-mask'
import { ProgressBar } from 'primereact/progressbar'
import 'primereact/resources/themes/saga-blue/theme.css'
import 'primereact/resources/primereact.min.css'
import { CommonUtils } from '../../utils/CommonUtils'
import { INpi } from '../../services/RequestHistoryStateManager/contracts'
import moment from 'moment'
import { ConfidenceScoreEnum } from '../../configuration/Enums/ConfidenceScoreEnum'

export interface IRequestDetailProps extends RouteComponentProps<any> {
	id: string | undefined
	coverageDiscoveryRequestStateManager: ICoverageDiscoveryRequestStateManager
	usersessionStateManager: IUserSessionStateManager
}

interface IConfidenceScoreFieldsState {
	Facility: boolean
	firstName: boolean
	middleName: boolean
	lastName: boolean
	DOB: boolean
	SSN: boolean
	partialSSN: boolean
	gender: boolean
	phone: boolean
	address1: boolean
	address2: boolean
	city: boolean
	state: boolean
	zip: boolean
}

interface IRequestDetailState {
	showErrorMessage: boolean
	errorMessage: string
	isLoading: boolean
	IsPageLoading: boolean
	IsDateValid: boolean
	IsDDateValid: boolean
	IsServiceBeginDateValid: boolean
	IsServiceEndDateValid: boolean
	IsAnyFacilityExist: boolean
	IsSubscriberSelected: boolean
	IsSubscriberGender: string
	IsGuarantorGender: string
	resultid: any
	timer: number
	showProgressbar: boolean
	showDataCompletionProgressbar: boolean
	confidenceScore: number
	guarantorconfidenceScore: number
	confidenceRating: number
	percent: number
	color: string
	confidenceStatus: string
	showAgeCheckBox: boolean
	checkAgeCheckBox: boolean
	modalForMinFieldsOnly: boolean
}
@observer
export class CoverageDiscoveryRequest extends React.Component<IRequestDetailProps, IRequestDetailState> {
	@injectProperty('ICoverageDiscoveryRequestApiClient')
	public readonly CoverageDiscoveryRequestApiClient!: ICoverageDiscoveryRequestApiClient
	private idobTextboxRef: React.RefObject<DatePicker>
	private ddobTextboxRef: React.RefObject<DatePicker>
	private serBeginDateTexboxRef: React.RefObject<DatePicker>
	private serviceEndDateTexboxRef: React.RefObject<DatePicker>
	public confidenceScoreFieldsState: IConfidenceScoreFieldsState
	public guarantorconfidenceScoreFieldsState: IConfidenceScoreFieldsState
	public validationFieldState: IConfidenceScoreFieldsState
	public guarantorvalidationFieldState: IConfidenceScoreFieldsState
	public isGuarantorSelectedManually: boolean
	constructor(props: Readonly<IRequestDetailProps>) {
		super(props)
		this.state = {
			showErrorMessage: false,
			errorMessage: '',
			isLoading: false,
			IsDateValid: false,
			IsDDateValid: false,
			IsPageLoading: true,
			IsServiceBeginDateValid: true,
			IsServiceEndDateValid: true,
			IsAnyFacilityExist: true,
			IsSubscriberSelected: true,
			IsSubscriberGender: '',
			IsGuarantorGender: '',
			resultid: '',
			timer: 0,
			showProgressbar: false,
			showDataCompletionProgressbar: false,
			confidenceScore: 0,
			guarantorconfidenceScore: 0,
			confidenceRating: 1,
			percent: 25,
			color: 'Red',
			confidenceStatus: 'Poor',
			showAgeCheckBox: false,
			checkAgeCheckBox: true,
			modalForMinFieldsOnly: false,
		}
		this.isGuarantorSelectedManually = false
		this.idobTextboxRef = React.createRef()
		this.ddobTextboxRef = React.createRef()
		this.serBeginDateTexboxRef = React.createRef()
		this.serviceEndDateTexboxRef = React.createRef()
		this.confidenceScoreFieldsState = {
			Facility: false,
			firstName: false,
			lastName: false,
			DOB: false,
			SSN: false,
			partialSSN: false,
			gender: false,
			phone: false,
			address1: false,
			address2: false,
			city: false,
			state: false,
			zip: false,
			middleName: false,
		} as IConfidenceScoreFieldsState

		this.guarantorconfidenceScoreFieldsState = {
			Facility: false,
			firstName: false,
			lastName: false,
			DOB: false,
			SSN: false,
			partialSSN: false,
			gender: false,
			phone: false,
			address1: false,
			address2: false,
			city: false,
			state: false,
			zip: false,
			middleName: false,
		} as IConfidenceScoreFieldsState

		this.validationFieldState = {
			Facility: false,
			middleName: false,
			firstName: false,
			lastName: false,
			DOB: false,
			SSN: false,
			partialSSN: false,
			gender: false,
			phone: false,
			address1: false,
			address2: false,
			city: false,
			state: false,
			zip: false,
		} as IConfidenceScoreFieldsState

		this.guarantorvalidationFieldState = {
			Facility: false,
			middleName: false,
			firstName: false,
			lastName: false,
			DOB: false,
			SSN: false,
			partialSSN: false,
			gender: false,
			phone: false,
			address1: false,
			address2: false,
			city: false,
			state: false,
			zip: false,
		} as IConfidenceScoreFieldsState
	}
	componentDidMount(): void {
		this.toggleValidationMessageShow = this.toggleValidationMessageShow.bind(this)
		this.closeDatePopupOnTab = this.closeDatePopupOnTab.bind(this)
		this.closeDDatePopupOnTab = this.closeDDatePopupOnTab.bind(this)
		this.closeSbDatePopupOnTab = this.closeSbDatePopupOnTab.bind(this)
		this.closeSeDatePopupOnTab = this.closeSeDatePopupOnTab.bind(this)
		this.setConfidenceScore = this.setConfidenceScore.bind(this)
		this.validateFieldsAndsetConfidenceScore = this.validateFieldsAndsetConfidenceScore.bind(this)
		this.resetDates = this.resetDates.bind(this)
		const RequestId = parseInt(this.props.match.params.id) || 0
		this.props.coverageDiscoveryRequestStateManager
			.loadCoverageDiscoveryTransactionStatusId(RequestId)
			.catch(error => {
				this.setIsPageLoadState(false)
				alert(error)
			})
			.then(() => {
				this.loadListItems()
			})

		this.onClear = this.onClear.bind(this)
	}

	setIsPageLoadState(val: boolean) {
		this.setState({
			IsPageLoading: val,
		})
	}

	closeDatePopupOnTab(e): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const ssn = document.getElementById('ssn')
			if (ssn !== null) {
				if (this.idobTextboxRef.current !== null) {
					this.idobTextboxRef.current.setOpen(false)
				}
				ssn.focus()
			}
		}
	}

	closeDDatePopupOnTab(e): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const guarantorSocialSecurityNumber = document.getElementById('guarantorSocialSecurityNumber')
			if (guarantorSocialSecurityNumber !== null) {
				if (this.ddobTextboxRef.current !== null) {
					this.ddobTextboxRef.current.setOpen(false)
				}
				guarantorSocialSecurityNumber.focus()
			}
		}
	}

	closeSbDatePopupOnTab(e): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const dobEnd = document.getElementById('dobEnd')
			if (dobEnd !== null) {
				if (this.idobTextboxRef.current !== null) {
					this.idobTextboxRef.current.setOpen(false)
				}
				dobEnd.focus()
			}
		}
	}

	closeSeDatePopupOnTab(e): void {
		if (e.key === 'Tab') {
			e.preventDefault()
			const subscriptionDtls = document.getElementById('radioSub')
			if (subscriptionDtls !== null) {
				if (this.idobTextboxRef.current !== null) {
					this.idobTextboxRef.current.setOpen(false)
				}
				subscriptionDtls.focus()
			}
		}
	}

	resetDates(e): void {
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceEndDate = new Date().toLocaleDateString()
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceBeginDate = new Date().toLocaleDateString()
	}

	validateAllSelectedRequestDetail() {
		const subscriberFieldsArray = Object.keys(this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.results)

		const guarantorFieldsArray = Object.keys(this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.results)

		this.setValidationMessagesOnSubmit(subscriberFieldsArray, this.validationFieldState)

		if (!this.state.IsSubscriberSelected) {
			this.setValidationMessagesOnSubmit(guarantorFieldsArray, this.guarantorvalidationFieldState)
		}
	}

	setValidationMessagesOnSubmit(FieldsArray, validationFieldState) {
		FieldsArray.forEach(element => {
			if (element == 'individualSocialSecurityNumber') {
				const item = document.getElementById('ssn')
				if (item != null) {
					item.classList.add('is-invalid')
				}
				validationFieldState.SSN = true
			} else if (element == 'customerEntityFacilityId') {
				const item = document.getElementById('ddFacilities')
				if (item != null) {
					item.classList.add('is-invalid')
				}
				validationFieldState.Facility = true
			} else if (element == 'individualDateOfBirth') {
				this.setState({ IsDateValid: false })
				validationFieldState.DOB = true
			} else {
				const item = document.getElementById(element)
				if (item != null) {
					item.classList.add('is-invalid')
				}
			}
			validationFieldState.firstName = true
			validationFieldState.lastName = true
		})
	}

	validateFieldsAndsetConfidenceScore(e): void {
		//set if a field is touched or not to show the proper validation
		switch (e.target.id) {
			case 'ddFacilities':
				this.validationFieldState.Facility = true
				this.guarantorvalidationFieldState.Facility = true
				break
			case 'individualFirstName':
			case 'guarantorFirstName':
				e.target.id == 'individualFirstName' ? (this.validationFieldState.firstName = true) : (this.guarantorvalidationFieldState.firstName = true)
				break
			case 'individualMiddleName':
			case 'depindividualMiddleInitial':
				e.target.id == 'individualMiddleName' ? (this.validationFieldState.middleName = true) : (this.guarantorvalidationFieldState.middleName = true)

				break
			case 'individualLastName':
			case 'guarantorLastName':
				e.target.id == 'individualLastName' ? (this.validationFieldState.lastName = true) : (this.guarantorvalidationFieldState.lastName = true)
				break
			case 'ssn':
				this.validationFieldState.SSN = true
				this.validationFieldState.DOB = true
				break
			case 'guarantorSocialSecurityNumber':
				this.guarantorvalidationFieldState.SSN = true
				this.guarantorvalidationFieldState.DOB = true
				break
			case 'idob':
			case 'ddob':
				e.target.id == 'idob' ? (this.validationFieldState.DOB = true) : (this.guarantorvalidationFieldState.DOB = true)
				break
			case 'HomePhone':
			case 'guarantorPhoneNumber':
				e.target.id == 'HomePhone' ? (this.validationFieldState.phone = true) : (this.guarantorvalidationFieldState.phone = true)
				break
			case 'radioSubFemale':
			case 'radioDepFemale':
				e.target.id == 'radioSubFemale' ? (this.validationFieldState.gender = true) : (this.guarantorvalidationFieldState.gender = true)
				break
			case 'address1':
			case 'guarantorAddress1':
				e.target.id == 'address1' ? (this.validationFieldState.address1 = true) : (this.guarantorvalidationFieldState.address1 = true)
				break
			case 'address2':
			case 'guarantorAddress2':
				e.target.id == 'address2' ? (this.validationFieldState.address2 = true) : (this.guarantorvalidationFieldState.address2 = true)
				break
			case 'city':
			case 'guarantorCity':
				e.target.id == 'city' ? (this.validationFieldState.city = true) : (this.guarantorvalidationFieldState.city = true)
				break
			case 'states':
			case 'gstates':
				e.target.id == 'states' ? (this.validationFieldState.state = true) : (this.guarantorvalidationFieldState.state = true)
				break
			case 'zipCode':
			case 'guarantorZipCode':
				e.target.id == 'zipCode' ? (this.validationFieldState.zip = true) : (this.guarantorvalidationFieldState.zip = true)
				break
			default:
				break
		}
		this.setConfidenceScore(e)
	}

	setConfidenceScore(e): void {
		const currentScore = this.state.confidenceScore
		const partialSSNregex = new RegExp(/\b^[0-9]{4}$\b/)
		if (e.target.value != '') {
			if (e.target.id == 'ddFacilities') {
				if (e.target.value > 0) {
					this.confidenceScoreFieldsState.Facility = true
					this.guarantorconfidenceScoreFieldsState.Facility = true
				} else {
					this.confidenceScoreFieldsState.Facility = false
					this.guarantorconfidenceScoreFieldsState.Facility = false
				}
			}
			if (e.target.id == 'individualFirstName') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid(e.target.id)) this.confidenceScoreFieldsState.firstName = true
				else this.confidenceScoreFieldsState.firstName = false
			}
			if (e.target.id == 'individualLastName') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid(e.target.id)) this.confidenceScoreFieldsState.lastName = true
				else this.confidenceScoreFieldsState.lastName = false
			}
			if (e.target.id == 'ssn') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualSocialSecurityNumber')) {
					this.confidenceScoreFieldsState.SSN = true
				} else {
					this.confidenceScoreFieldsState.SSN = false
				}
				e.target.value!.match(partialSSNregex) ? (this.confidenceScoreFieldsState.partialSSN = true) : (this.confidenceScoreFieldsState.partialSSN = false)
			}
			if (e.target.id == 'HomePhone') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualPhoneNumber')) this.confidenceScoreFieldsState.phone = true
				else this.confidenceScoreFieldsState.phone = false
			}
			if (e.target.id == 'radioSubMale' || e.target.id == 'radioSubFemale') {
				this.confidenceScoreFieldsState.gender = true
			}

			if (e.target.id == 'address1') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress1')) this.confidenceScoreFieldsState.address1 = true
				else this.confidenceScoreFieldsState.address1 = false
			}

			if (e.target.id == 'address2') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress2')) this.confidenceScoreFieldsState.address2 = true
				else this.confidenceScoreFieldsState.address2 = false
			}

			if (e.target.id == 'city') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualCity')) this.confidenceScoreFieldsState.city = true
				else this.confidenceScoreFieldsState.city = false
			}

			if (e.target.id == 'states') {
				if (e.target.value > 0) this.confidenceScoreFieldsState.state = true
				else this.confidenceScoreFieldsState.state = false
			}

			if (e.target.id == 'zipCode') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualZip')) this.confidenceScoreFieldsState.zip = true
				else this.confidenceScoreFieldsState.zip = false
			}

			if (e.target.id == 'guarantorFirstName') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.firstName = true
				else this.confidenceScoreFieldsState.firstName = false
			}
			if (e.target.id == 'guarantorLastName') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.lastName = true
				else this.guarantorconfidenceScoreFieldsState.lastName = false
			}
			if (e.target.id == 'guarantorSocialSecurityNumber') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorSocialSecurityNumber')) {
					this.guarantorconfidenceScoreFieldsState.SSN = true
				} else {
					this.guarantorconfidenceScoreFieldsState.SSN = false
				}
				e.target.value!.match(partialSSNregex) ? (this.guarantorconfidenceScoreFieldsState.partialSSN = true) : (this.guarantorconfidenceScoreFieldsState.partialSSN = false)
			}
			if (e.target.id == 'guarantorZipCode') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorZip')) this.guarantorconfidenceScoreFieldsState.zip = true
				else this.guarantorconfidenceScoreFieldsState.zip = false
			}

			if (e.target.id == 'guarantorPhoneNumber') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.phone = true
				else this.guarantorconfidenceScoreFieldsState.phone = false
			}

			if (e.target.id == 'radioDepMale' || e.target.id == 'radioDepFemale') {
				this.guarantorconfidenceScoreFieldsState.gender = true
			}

			if (e.target.id == 'guarantorAddress1') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.address1 = true
				else this.guarantorconfidenceScoreFieldsState.address1 = false
			}

			if (e.target.id == 'guarantorAddress2') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.address2 = true
				else this.guarantorconfidenceScoreFieldsState.address2 = false
			}
			if (e.target.id == 'guarantorCity') {
				if (this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid(e.target.id)) this.guarantorconfidenceScoreFieldsState.city = true
				else this.guarantorconfidenceScoreFieldsState.city = false
			}

			if (e.target.id == 'gstates') {
				if (e.target.value > 0) this.guarantorconfidenceScoreFieldsState.state = true
				else this.guarantorconfidenceScoreFieldsState.state = false
			}
		} else {
			switch (e.target.id) {
				case 'ddFacilities':
					this.confidenceScoreFieldsState.Facility = false
					this.guarantorconfidenceScoreFieldsState.Facility = false
					break
				case 'individualFirstName':
				case 'guarantorFirstName':
					e.target.id == 'individualFirstName' ? (this.confidenceScoreFieldsState.firstName = false) : (this.guarantorconfidenceScoreFieldsState.firstName = false)
					break
				case 'individualLastName':
				case 'guarantorLastName':
					e.target.id == 'individualLastName' ? (this.confidenceScoreFieldsState.lastName = false) : (this.guarantorconfidenceScoreFieldsState.lastName = false)
					break
				case 'ssn':
				case 'guarantorSocialSecurityNumber':
					e.target.id == 'ssn' ? (this.confidenceScoreFieldsState.SSN = false) : (this.guarantorconfidenceScoreFieldsState.SSN = false)
					break
				case 'idob':
				case 'ddob':
					e.target.id == 'idob' ? (this.confidenceScoreFieldsState.DOB = false) : (this.guarantorconfidenceScoreFieldsState.DOB = false)
					break
				case 'HomePhone':
				case 'guarantorPhoneNumber':
					e.target.id == 'HomePhone' ? (this.confidenceScoreFieldsState.phone = false) : (this.guarantorconfidenceScoreFieldsState.phone = false)
					break
				case 'radioSubFemale':
				case 'radioDepFemale':
					e.target.id == 'radioSubFemale' ? (this.confidenceScoreFieldsState.gender = false) : (this.guarantorconfidenceScoreFieldsState.gender = false)
					break
				case 'address1':
				case 'guarantorAddress1':
					e.target.id == 'address1' ? (this.confidenceScoreFieldsState.address1 = false) : (this.guarantorconfidenceScoreFieldsState.address1 = false)
					break
				case 'address2':
				case 'guarantorAddress2':
					e.target.id == 'address2' ? (this.confidenceScoreFieldsState.address2 = false) : (this.guarantorconfidenceScoreFieldsState.address2 = false)
					break
				case 'city':
				case 'guarantorCity':
					e.target.id == 'city' ? (this.confidenceScoreFieldsState.city = false) : (this.guarantorconfidenceScoreFieldsState.city = false)
					break
				case 'states':
				case 'gstates':
					e.target.id == 'states' ? (this.confidenceScoreFieldsState.state = false) : (this.guarantorconfidenceScoreFieldsState.state = false)
					break
				case 'zipCode':
				case 'guarantorZipCode':
					e.target.id == 'zipCode' ? (this.confidenceScoreFieldsState.zip = false) : (this.guarantorconfidenceScoreFieldsState.zip = false)
					break
				default:
					break
			}
		}
		if (this.state.IsSubscriberSelected) {
			this.calculateConfidenceScore(this.confidenceScoreFieldsState)
		} else {
			this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
		}
		// if (this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualFirstName != '') {
		// 	this.setState({ confidenceScore: currentScore + 2 })
		// }
	}

	calculateConfidenceScore(confidenceScoreFieldsState): void {
		let currentScore = 0

		if (confidenceScoreFieldsState.Facility) {
			currentScore += ConfidenceScoreEnum.Facility
		}
		if (confidenceScoreFieldsState.firstName) {
			currentScore += ConfidenceScoreEnum.FirstName
		}
		if (confidenceScoreFieldsState.lastName) {
			currentScore += ConfidenceScoreEnum.LastName
		}
		if (confidenceScoreFieldsState.DOB) {
			currentScore += ConfidenceScoreEnum.DOB
		}
		if (confidenceScoreFieldsState.SSN) {
			if (confidenceScoreFieldsState.partialSSN) currentScore += ConfidenceScoreEnum.PartialSSN
			else currentScore += ConfidenceScoreEnum.SSN
		}
		if (confidenceScoreFieldsState.gender) {
			currentScore += ConfidenceScoreEnum.Gender
		}

		if (confidenceScoreFieldsState.phone) {
			currentScore += ConfidenceScoreEnum.PhoneNumber
		}
		if (confidenceScoreFieldsState.address1) {
			currentScore += ConfidenceScoreEnum.Address1
		}
		if (confidenceScoreFieldsState.address2) {
			currentScore += ConfidenceScoreEnum.Address2
		}
		if (confidenceScoreFieldsState.city) {
			currentScore += ConfidenceScoreEnum.City
		}
		if (confidenceScoreFieldsState.state) {
			currentScore += ConfidenceScoreEnum.State
		}
		if (confidenceScoreFieldsState.zip) {
			currentScore += ConfidenceScoreEnum.Zip
		}

		const confidenceScoreFieldsList = Object.entries(this.confidenceScoreFieldsState)
		const isValueEntered = confidenceScoreFieldsList
			.map(([key, val], i) => {
				return val
			})
			.includes(true)

		// isValueEntered = this.confidenceScoreFieldsState.firstName || this.confidenceScoreFieldsState.lastName
		// 					|| this.confidenceScoreFieldsState.DOB || this.confidenceScoreFieldsState.SSN

		if (currentScore > 0 || isValueEntered) this.setState({ showDataCompletionProgressbar: true })
		else this.setState({ showDataCompletionProgressbar: false })

		const subscriberMinConfidence = this.confidenceScoreFieldsState.Facility && this.confidenceScoreFieldsState.firstName && this.confidenceScoreFieldsState.lastName && ((this.confidenceScoreFieldsState.SSN && !this.confidenceScoreFieldsState.partialSSN) || this.confidenceScoreFieldsState.DOB)

		const minConfidence = subscriberMinConfidence && this.confidenceScoreFieldsState.Facility && confidenceScoreFieldsState.firstName && confidenceScoreFieldsState.lastName && ((confidenceScoreFieldsState.SSN && !confidenceScoreFieldsState.partialSSN) || confidenceScoreFieldsState.DOB)

		if (this.state.IsSubscriberSelected) {
			this.setState(
				{
					confidenceScore: currentScore,
				},
				() => {
					this.setColorAndStaus(minConfidence, this.state.confidenceScore)
				},
			)
		} else {
			this.setState(
				{
					guarantorconfidenceScore: currentScore,
				},
				() => {
					this.setColorAndStaus(minConfidence, this.state.guarantorconfidenceScore)
				},
			)
		}
	}

	setColorAndStaus(minConfidence, confidenceScore: any): void {
		if (confidenceScore == 0) this.setState({ confidenceRating: 1, percent: 25, color: 'Red', confidenceStatus: 'Poor' })
		else if (minConfidence && confidenceScore > 5 && confidenceScore <= 7) {
			this.setState({ confidenceRating: 2, percent: 50, color: 'orange', confidenceStatus: 'Ok' })
		} else if (minConfidence && confidenceScore >= 8 && confidenceScore <= 26) {
			this.setState({ confidenceRating: 3, percent: 75, color: 'yellow', confidenceStatus: 'Better' })
		} else if (minConfidence && confidenceScore >= 27 && confidenceScore <= 30) {
			this.setState({ confidenceRating: 4, percent: 100, color: 'green', confidenceStatus: 'Best' })
		} else if (!minConfidence || (confidenceScore <= 5 && confidenceScore != 0)) {
			this.setState({ confidenceRating: 1, percent: 25, color: 'Red', confidenceStatus: 'Poor' })
		}
	}

	loadListItems(): void {
		this.props.coverageDiscoveryRequestStateManager
			.loadAvailableStates()
			.catch(error => {
				alert(error)
			})
			.then(() => {
				const statesFromApi = this.props.coverageDiscoveryRequestStateManager.availableStates.map(team => {
					return { id: team.id, name: team.name }
				})
				statesFromApi.unshift({ id: 0, name: 'Select State' })
				this.props.coverageDiscoveryRequestStateManager.availableStates = statesFromApi

				this.props.coverageDiscoveryRequestStateManager
					.loadAvailableFacilities()
					.catch(error => {
						this.setIsPageLoadState(false)
						this.onClear()
						alert(error)
					})
					.then(() => {
						const facilitiesFromApi: INpi[] = this.props.coverageDiscoveryRequestStateManager.availableFacilities

						if (facilitiesFromApi.length < 1) {
							this.setState({
								IsAnyFacilityExist: false,
							})
						} else {
							facilitiesFromApi.unshift({ id: 0, name: 'Select Facility' } as INpi)
							this.props.coverageDiscoveryRequestStateManager.availableFacilities = facilitiesFromApi
						}

						this.onClear()

						//Implemented the Rerun functionality.
						//And Pre-populate the existing data.
						const RequestId = parseInt(this.props.match.params.id) || 0
						if (RequestId > 0) {
							this.props.coverageDiscoveryRequestStateManager
								.loadRequestDetail(RequestId)
								.then(response => {
									if (response !== null) {
										this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail(response)

										this.setState({
											IsSubscriberGender: response.individualGender || '',
											IsGuarantorGender: response.guarantorGender || '',
											IsSubscriberSelected: response.guarantorFirstName === null,
											IsDateValid: response.individualDateOfBirth !== null || response.individualSocialSecurityNumber !== null,
											IsDDateValid: response.guarantorDateOfBirth !== null || response.guarantorSocialSecurityNumber !== null,
										})
										this.setProgressBarForRerun()
										if (this.IsAgeLessThan26Years(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth) && !(response.guarantorFirstName === null)) this.setState({ showAgeCheckBox: true })
									}
									this.setIsPageLoadState(false)
								})
								.catch(error => {
									this.setIsPageLoadState(false)
								})
						} else {
							this.setIsPageLoadState(false)
						}
					})
			})
	}

	setProgressBarForRerun(): void {
		const requestDetail = this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail
		if (requestDetail.customerEntityFacilityId > 0) {
			this.confidenceScoreFieldsState.Facility = true
			this.guarantorconfidenceScoreFieldsState.Facility = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualFirstName)) {
			this.confidenceScoreFieldsState.firstName = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualLastName)) {
			this.confidenceScoreFieldsState.lastName = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualDateOfBirth)) {
			this.confidenceScoreFieldsState.DOB = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualSocialSecurityNumber)) {
			this.confidenceScoreFieldsState.SSN = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualGender)) {
			this.confidenceScoreFieldsState.gender = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualPhoneNumber)) {
			this.confidenceScoreFieldsState.phone = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualAddress1)) {
			this.confidenceScoreFieldsState.address1 = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualAddress2)) {
			this.confidenceScoreFieldsState.address2 = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualCity)) {
			this.confidenceScoreFieldsState.city = true
		}
		if (requestDetail.individualStateCodeId != null && requestDetail.individualStateCodeId > 0) {
			this.confidenceScoreFieldsState.state = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.individualZip)) {
			this.confidenceScoreFieldsState.zip = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorFirstName)) {
			this.guarantorconfidenceScoreFieldsState.firstName = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorLastName)) {
			this.guarantorconfidenceScoreFieldsState.lastName = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorDateOfBirth)) {
			this.guarantorconfidenceScoreFieldsState.DOB = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorSocialSecurityNumber)) {
			this.guarantorconfidenceScoreFieldsState.SSN = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorGender)) {
			this.guarantorconfidenceScoreFieldsState.gender = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorPhoneNumber)) {
			this.guarantorconfidenceScoreFieldsState.phone = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorAddress1)) {
			this.guarantorconfidenceScoreFieldsState.address1 = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorAddress2)) {
			this.guarantorconfidenceScoreFieldsState.address2 = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorCity)) {
			this.guarantorconfidenceScoreFieldsState.city = true
		}
		if (requestDetail.guarantorStateCodeId != null && requestDetail.guarantorStateCodeId > 0) {
			this.guarantorconfidenceScoreFieldsState.state = true
		}
		if (!CommonUtils.isNullUndefinedEmpty(requestDetail.guarantorZip)) {
			this.guarantorconfidenceScoreFieldsState.zip = true
		}
		this.state.IsSubscriberSelected ? this.calculateConfidenceScore(this.confidenceScoreFieldsState) : this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
	}

	onCancel(event: any): void {
		event.preventDefault()
		this.props.history.push('/CoverageDiscoveryRequest/0')
	}

	validateSubscriberGuarantor(): boolean {
		return this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isAllFieldsValid() && this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isAllFieldsValid()
	}

	onSave(event: any): void {
		event.preventDefault()
		//added below validation to show validation error messages on submit
		this.validateAllSelectedRequestDetail()

		if (this.AreMinFieldsOnlySet() && !this.state.modalForMinFieldsOnly) {
			this.setState({ modalForMinFieldsOnly: true })
			return
		} else {
			this.setState({ modalForMinFieldsOnly: false })
		}
		if (this.state.IsSubscriberSelected ? this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isAllFieldsValid() : this.validateSubscriberGuarantor()) {
			let val = 0
			this.setState({
				isLoading: true,
				showProgressbar: true,
				timer: val,
			})
			this.props.coverageDiscoveryRequestStateManager
				.saveOrUpdateCoverageDiscoveryRequestDetail()
				.then(result => {
					if (result.id !== 0) {
						const interval = setInterval(() => {
							val += Math.round((SettingsManager.COVERAGE_DISCOVERY_RESPONSE_INTERVAL / SettingsManager.COVERAGE_DISCOVERY_TOTAL_POLLING_INTERVAL) * 100)
							if (val >= 100) {
								clearInterval(interval)
								this.props.coverageDiscoveryRequestStateManager.updateCDStatusTimeout(result.id).then(() => {
									this.setState({
										showProgressbar: false,
										showErrorMessage: true,
										errorMessage: 'Your request has timed out. Please try again later.',
										isLoading: false,
									})
								})
								return
							}
							this.props.coverageDiscoveryRequestStateManager
								.loadCoverageDiscoveryTransactionStatusId(result.id)
								.then(() => {
									if (this.props.coverageDiscoveryRequestStateManager.isResponseAvailable) {
										this.setState({
											showProgressbar: false,
											timer: 0,
										})
										this.props.history.push('/CoverageDiscoveryResponse/' + result.id)
										this.onClear()
										clearInterval(interval)
									} else {
										this.setState({
											showProgressbar: true,
											timer: val,
										})
									}
								})
								.catch(error => {
									console.log(error)
									this.setState({
										isLoading: false,
									})
									clearInterval(interval)
								})
						}, SettingsManager.COVERAGE_DISCOVERY_RESPONSE_INTERVAL)
					}
				})
				.catch(error => {
					console.log(error)
					this.setState({
						showErrorMessage: true,
						errorMessage: error.toString(),
						showProgressbar: false,
						timer: 0,
						isLoading: false,
					})
				})
		}
	}

	toggleValidationMessageShow(): void {
		this.setState({
			showErrorMessage: !this.state.showErrorMessage,
			errorMessage: '',
		})
	}

	clearGuarantor(): void {
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorFirstName = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorMiddleName = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorLastName = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress1 = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress2 = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorCity = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorStateCodeId = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorSocialSecurityNumber = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorDateOfBirth = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorPhoneNumber = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorGender = null
		this.setState({ IsGuarantorGender: '', IsDDateValid: false, guarantorconfidenceScore: 0 })
		this.confidenceScoreFieldsStateToInitial(this.guarantorconfidenceScoreFieldsState)
		this.confidenceScoreFieldsStateToInitial(this.guarantorvalidationFieldState)
	}

	onClear(): void {
		const facilities = this.props.coverageDiscoveryRequestStateManager.availableFacilities
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId = facilities.length > 0 ? facilities[0].id : 0
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceBeginDate = new Date().toDateString()
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceEndDate = new Date().toDateString()
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualFirstName = ''
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualLastName = ''
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber = null
		this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualGender = null
		this.clearGuarantor()
		this.setState({
			showErrorMessage: false,
			errorMessage: '',
			IsServiceBeginDateValid: true,
			IsServiceEndDateValid: true,
			IsDateValid: false,
			IsDDateValid: false,
			IsSubscriberGender: '',
			IsGuarantorGender: '',
			confidenceScore: 0,
			guarantorconfidenceScore: 0,
			showDataCompletionProgressbar: false,
			showAgeCheckBox: false,
		})
		this.confidenceScoreFieldsStateToInitial(this.validationFieldState)
		this.confidenceScoreFieldsStateToInitial(this.confidenceScoreFieldsState)
	}

	confidenceScoreFieldsStateToInitial(confidenceScoreFieldsState: IConfidenceScoreFieldsState) {
		confidenceScoreFieldsState.firstName = false
		confidenceScoreFieldsState.middleName = false
		confidenceScoreFieldsState.lastName = false
		confidenceScoreFieldsState.DOB = false
		confidenceScoreFieldsState.SSN = false
		confidenceScoreFieldsState.gender = false
		confidenceScoreFieldsState.phone = false
		confidenceScoreFieldsState.address1 = false
		confidenceScoreFieldsState.address2 = false
		confidenceScoreFieldsState.city = false
		confidenceScoreFieldsState.state = false
		confidenceScoreFieldsState.zip = false
		confidenceScoreFieldsState.Facility = false
	}

	handleIdob = e => {
		this.validationFieldState.DOB = true
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualDateOfBirth: e !== null ? new Date(e).toDateString() : null })
		const ssn = document.getElementById('ssn') as HTMLInputElement
		const radio = document.getElementById('radioDep') as HTMLInputElement
		const isValidSSN = (ssn !== null && ssn.value === null) || ssn.value.trim() === '' || (!ssn.value.match(/\b[0-9]{3}[-][0-9]{2}[-][0-9]{4}\b/) && !ssn.value.match(/\b[0-9]{9}\b/))
		const selectedDate = document.getElementById('idob') as HTMLInputElement

		if (e === null) {
			if (isValidSSN) {
				this.setState({ IsDateValid: false })
				this.confidenceScoreFieldsState.DOB = false
			} else {
				this.setState({ IsDateValid: true })
			}
			this.isGuarantorSelectedManually
				? this.setState({ showAgeCheckBox: false, IsSubscriberSelected: false })
				: this.setState({ showAgeCheckBox: false, IsSubscriberSelected: true }, () => {
					this.calculateConfidenceScore(this.confidenceScoreFieldsState)
				  })
			return
		}
		if (e > new Date()) {
			this.setState({ IsDateValid: false })
			if (this.isGuarantorSelectedManually) {
				this.setState({ showAgeCheckBox: false, IsSubscriberSelected: false })
			} else
				this.setState({ showAgeCheckBox: false, IsSubscriberSelected: true }, () => {
					this.calculateConfidenceScore(this.confidenceScoreFieldsState)
				})

			this.confidenceScoreFieldsState.DOB = false
			return
		} else {
			this.setState({ IsDateValid: true })
			if (this.IsAgeLessThan26Years(e)) {
				this.setState({ showAgeCheckBox: true, IsSubscriberSelected: false, checkAgeCheckBox: true }, () => {
					this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
				})
			} else if (this.isGuarantorSelectedManually) {
				this.setState({ showAgeCheckBox: false, IsSubscriberSelected: false })
			} else {
				this.setState({ showAgeCheckBox: false, IsSubscriberSelected: true }, () => {
					this.calculateConfidenceScore(this.confidenceScoreFieldsState)
				})
			}
			this.confidenceScoreFieldsState.DOB = true
		}
		setTimeout(() => this.CheckManualEnteredDate(isValidSSN), 1000)
	}
	IsAgeLessThan26Years(e): boolean {
		const today = new Date()
		const birthDate = new Date(e)
		let age = today.getFullYear() - birthDate.getFullYear()
		const m = today.getMonth() - birthDate.getMonth()
		if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
			age--
		}
		if (age < 26) return true
		else return false
	}

	handleCheck(value: boolean): any {
		this.setState(
			{
				IsSubscriberSelected: true,
				showAgeCheckBox: false,
			},
			() => {
				this.calculateConfidenceScore(this.confidenceScoreFieldsState)
			},
		)
		this.clearGuarantor()
	}

	dhandleChange = e => {
		this.guarantorvalidationFieldState.DOB = true

		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorDateOfBirth: e !== null ? new Date(e).toDateString() : null })
		const gssn = document.getElementById('guarantorSocialSecurityNumber') as HTMLInputElement
		const isValidSSN = (gssn !== null && gssn.value === null) || gssn.value.trim() === '' || (!gssn.value.match(/\b[0-9]{3}[-][0-9]{2}[-][0-9]{4}\b/) && !gssn.value.match(/\b[0-9]{9}\b/))
		if (e === null) {
			if (isValidSSN) {
				this.setState({ IsDDateValid: false })
				this.guarantorconfidenceScoreFieldsState.DOB = false
				this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
			}
			return
		}
		if (e > new Date()) {
			this.setState({ IsDDateValid: false })
			this.guarantorconfidenceScoreFieldsState.DOB = false
			this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
			return
		} else {
			this.setState({ IsDDateValid: true })
			this.guarantorconfidenceScoreFieldsState.DOB = true
			this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
		}
		setTimeout(() => this.CheckManualEnteredGuarantorDate(isValidSSN), 1000)
	}
	serviceBeginhandleChange = e => {
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, serviceBeginDate: e !== null ? new Date(e).toDateString() : new Date().toDateString() })
		if (e === null) return
		setTimeout(() => this.CheckManualEnteredServiceBeginDate(), 1000)
	}

	serviceEndhandleChange = e => {
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, serviceEndDate: e !== null ? new Date(e).toDateString() : new Date().toDateString() })
		if (e === null) return
		setTimeout(() => this.CheckManualEnteredServiceEndDate(), 1000)
	}

	CheckManualEnteredDate(isValidSSN) {
		const selectedDate = document.getElementById('idob') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualDateOfBirth: null })

			if (isValidSSN) this.setState({ IsDateValid: false })
			return
		} else {
			this.setState({ IsDateValid: true })
		}
	}

	CheckManualEnteredGuarantorDate(isValidSSN) {
		const selectedDate = document.getElementById('ddob') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorDateOfBirth: null })
			if (isValidSSN) this.setState({ IsDDateValid: false })
			return
		} else {
			this.setState({ IsDDateValid: true })
		}
	}

	CheckManualEnteredServiceBeginDate() {
		const selectedDate = document.getElementById('dobBegin') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, serviceBeginDate: new Date().toDateString() })
			return
		} else {
			this.setState({ IsServiceBeginDateValid: true })
		}
	}

	CheckManualEnteredServiceEndDate() {
		const selectedDate = document.getElementById('dobEnd') as HTMLInputElement
		if (selectedDate != null && selectedDate.value != null && selectedDate.value.match(SettingsManager.DATE_REGULAR_EXPRESSION) === null) {
			alert(selectedDate.value + ' is not valid Date')
			this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, serviceEndDate: new Date().toDateString() })
			return
		} else {
			this.setState({ IsServiceEndDateValid: true })
		}
	}

	handleSubscriberGender = event => {
		this.setState({ IsSubscriberGender: event.target.value })
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualGender: event.target.value })
	}

	handleGuarantorGender = event => {
		this.setState({ IsGuarantorGender: event.target.value })
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorGender: event.target.value })
	}

	renderSubscriber(): any {
		return (
			<Container>
				<Row>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							First Name<span className="red">*</span>
						</Label>
						<Input type="text" id="individualFirstName" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualFirstName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualFirstName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualFirstName')} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualFirstName') && this.validationFieldState.firstName} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualFirstName')}</FormFeedback>
					</Col>
					<Col xs="4">
						<Label className="entryPrompt w-100">Middle Name</Label>
						<Input type="text" id="individualMiddleName" className="rounded-lg miText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualMiddleName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualMiddleName') && this.validationFieldState.middleName} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualMiddleName')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualMiddleName')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							Last Name<span className="red">*</span>
						</Label>
						<Input type="text" id="individualLastName" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualLastName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualLastName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualLastName')} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualLastName') && this.validationFieldState.lastName} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualLastName')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">Gender</Label>
						<FormGroup tag="fieldset">
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radioSub" id="radioSubMale" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.handleSubscriberGender(e)} value="M" checked={this.state.IsSubscriberGender === 'M' && true} /> Male
								</Label>
							</FormGroup>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radioSub" id="radioSubFemale" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.handleSubscriberGender(e)} value="F" checked={this.state.IsSubscriberGender === 'F' && true} /> Female
								</Label>
							</FormGroup>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col xs="2">
						<Label for="idob" className="entryPrompt w-75">
							Date Of Birth<span className="red">*</span>
						</Label>
						<DatePicker onBlur={this.validateFieldsAndsetConfidenceScore} onKeyDown={this.closeDatePopupOnTab} ref={this.idobTextboxRef} valid={'dob dobInputValid'} className={!this.validationFieldState.DOB ? 'dob iDobInput' : this.state.IsDateValid ? 'dob dobInputValid' : 'dob dobInputInvalid'} placeholderText="mm/dd/yyyy" showYearDropdown showMonthDropdown dropdownMode="select" peekNextMonth useShortMonthInDropdown name="idob" id="idob" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} selected={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth ? new Date(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth) : null} onChange={e => this.handleIdob(e)} />
						<FormFeedback id="idobFeedBack" className={!this.validationFieldState.DOB ? 'hideDateValidation' : !this.state.IsDateValid ? 'show' : 'dob hideDateValidation'}>
							{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualDateOfBirth')}
						</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							Social Security Number<span className="red">*</span>
						</Label>
						<Input type="text" id="ssn" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.handleSsn(e)} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber.toString()} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualSocialSecurityNumber') && this.validationFieldState.SSN} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualSocialSecurityNumber') && this.validationFieldState.SSN} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualSocialSecurityNumber')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">Phone Number</Label>
						<Input type="text" id="HomePhone" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualPhoneNumber: e.target.value.replace(/\D/, '') })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualPhoneNumber') && this.validationFieldState.phone} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualPhoneNumber')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualPhoneNumber')}</FormFeedback>
					</Col>
				</Row>
				<Row>
					<Col xs="4">
						<Label className="entryPrompt w-100">Address1</Label>
						<Input type="text" name="text" id="address1" className="rounded-lg addressText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualAddress1: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress1') && this.validationFieldState.address1} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress1')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualAddress1')}</FormFeedback>
					</Col>
					<Col xs="4">
						<Label className="entryPrompt w-100">Address2</Label>
						<Input type="text" name="text" id="address2" className="rounded-lg addressText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualAddress2: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress2') && this.validationFieldState.address2} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualAddress2')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualAddress2')}</FormFeedback>
					</Col>
				</Row>
				<Row>
					<Col xs="2">
						<Label className="entryPrompt w-75">City</Label>
						<Input type="text" id="city" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualCity: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualCity') && this.validationFieldState.city} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualCity')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualCity')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">State</Label>
						<Input type="select" name="states" className="rounded-lg w-75 non-uniform" id="states" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualStateCodeId: parseInt(e.target.value) })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId === null ? 0 : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualStateCodeId') && this.validationFieldState.state} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualStateCodeId')}>
							{this.props.coverageDiscoveryRequestStateManager.availableStates.map(c => (
								<option key={c.id} value={c.id}>
									{c.name}
								</option>
							))}
						</Input>
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualStateCodeId')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">ZIP Code</Label>
						<Input type="text" id="zipCode" className="rounded-lg w-75" placeholder="" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualZip: e.target.value.replace(/[^0-9-]/, '') })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip === null || typeof this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip === 'undefined' ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip.toString()} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualZip') && this.validationFieldState.zip} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('individualZip')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('individualZip')}</FormFeedback>
					</Col>
				</Row>
				<Row style={{ display: this.state.showAgeCheckBox ? 'block' : 'none' }}>
					<Col>
						<Input type="checkbox" name="checkIfAgeLessThan26" checked={this.state.checkAgeCheckBox} onChange={(e): void => this.handleCheck(e.target.checked)} />
						&nbsp;
						<Label>Subscriber is under the age of 26. Please provide guarantor details below.</Label>
					</Col>
				</Row>
			</Container>
		)
	}
	handleSsn(e: any): any {
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, individualSocialSecurityNumber: e.target.value.replace(/[^0-9-]/, '') })

		const dob = document.getElementById('idob') as HTMLInputElement
		if (dob !== null && (CommonUtils.isUndefinedOrNull(dob.value) || dob.value.trim() === '')) {
			if (e !== null && !CommonUtils.isUndefinedOrNull(e.target.value) && e.target.value.trim() !== '') {
				if (!e.target.value.match(/\b[0-9]{3}[-][0-9]{2}[-][0-9]{4}\b/) && !e.target.value.match(/\b[0-9]{9}\b/)) {
					if (!e.target.value.match(/\b^[0-9]{4}$\b/)) {
						this.setState({ IsDateValid: false })
					} else if (dob.value.trim() !== '' && dob.value.trim() !== null) this.setState({ IsDateValid: true })
					else this.setState({ IsDateValid: false })
				} else this.setState({ IsDateValid: true })
			} else this.setState({ IsDateValid: false })
		}
	}
	handlegSsn(e: any): any {
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorSocialSecurityNumber: e.target.value.replace(/[^0-9-]/, '') })

		const ddob = document.getElementById('ddob') as HTMLInputElement
		if (ddob !== null && (CommonUtils.isUndefinedOrNull(ddob.value) || ddob.value.trim() === '')) {
			if (e !== null && !CommonUtils.isUndefinedOrNull(e.target.value) && e.target.value.trim() !== '') {
				if (!e.target.value.match(/\b[0-9]{3}[-][0-9]{2}[-][0-9]{4}\b/) && !e.target.value.match(/\b[0-9]{9}\b/)) {
					if (!e.target.value.match(/\b^[0-9]{4}$\b/)) {
						this.setState({ IsDDateValid: false })
					} else if (ddob.value.trim() !== '' && ddob.value.trim() !== null) this.setState({ IsDDateValid: true })
					else this.setState({ IsDDateValid: false })
				} else this.setState({ IsDDateValid: true })
			} else this.setState({ IsDDateValid: false })
		}
	}

	renderGuarantor(): any {
		return (
			<Container>
				<Row>
					<Col>
						<h3>Guarantor Details</h3>
						<hr />
					</Col>
				</Row>
				<Row>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							First Name<span className="red">*</span>
						</Label>
						<Input type="text" id="guarantorFirstName" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorFirstName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorFirstName === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorFirstName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorFirstName')} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorFirstName') && this.guarantorvalidationFieldState.firstName} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorFirstName')}</FormFeedback>
					</Col>
					<Col xs="4">
						<Label className="entryPrompt w-100">Middle Name</Label>
						<Input type="text" id="depindividualMiddleInitial" className="rounded-lg miText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorMiddleName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorMiddleName === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorMiddleName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorMiddleName') && this.guarantorvalidationFieldState.middleName} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorMiddleName')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorMiddleName')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							Last Name<span className="red">*</span>
						</Label>
						<Input type="text" id="guarantorLastName" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorLastName: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorLastName === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorLastName} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorLastName')} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorLastName') && this.guarantorvalidationFieldState.lastName} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorLastName')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">Gender</Label>
						<FormGroup tag="fieldset">
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radioDep" id="radioDepMale" onBlur={this.setConfidenceScore} onChange={e => this.handleGuarantorGender(e)} value="M" checked={this.state.IsGuarantorGender === 'M' && true} /> Male
								</Label>
							</FormGroup>
							<FormGroup check>
								<Label check>
									<Input type="radio" name="radioDep" id="radioDepFemale" onBlur={this.setConfidenceScore} onChange={e => this.handleGuarantorGender(e)} value="F" checked={this.state.IsGuarantorGender === 'F' && true} /> Female
								</Label>
							</FormGroup>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col xs="2">
						<Label for="ddob" className="entryPrompt w-75">
							Date Of Birth<span className="red">*</span>
						</Label>
						<DatePicker onBlur={this.setConfidenceScore} onKeyDown={this.closeDDatePopupOnTab} ref={this.ddobTextboxRef} className={!this.guarantorvalidationFieldState.DOB ? 'dob iDobInput' : this.state.IsDDateValid ? 'dob dobInputValid' : 'dob dobInputInvalid'} placeholderText="mm/dd/yyyy" showYearDropdown showMonthDropdown dropdownMode="select" peekNextMonth useShortMonthInDropdown name="ddob" id="ddob" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} selected={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorDateOfBirth ? new Date(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorDateOfBirth) : null} onChange={e => this.dhandleChange(e)} />
						<FormFeedback id="ddobFeedBack" className={!this.guarantorvalidationFieldState.DOB ? 'hideDateValidation' : !this.state.IsDDateValid ? 'show' : 'dob hideDateValidation'}>
							{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorDateOfBirth')}
						</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-100">
							Social Security Number<span className="red">*</span>
						</Label>
						<Input type="text" id="guarantorSocialSecurityNumber" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.handlegSsn(e)} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorSocialSecurityNumber === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorSocialSecurityNumber.toString()} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorSocialSecurityNumber') && this.guarantorvalidationFieldState.SSN} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorSocialSecurityNumber') && this.guarantorvalidationFieldState.SSN} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorSocialSecurityNumber')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">Phone Number:</Label>
						<Input
							type="text"
							id="guarantorPhoneNumber"
							className="rounded-lg w-75"
							onBlur={this.validateFieldsAndsetConfidenceScore}
							onChange={e =>
								this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({
									...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail,
									guarantorPhoneNumber: e.target.value.replace(/\D/, ''),
								})
							}
							value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorPhoneNumber === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorPhoneNumber}
							valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorPhoneNumber') && this.guarantorvalidationFieldState.phone}
							invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorPhoneNumber')}
						/>
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorPhoneNumber')}</FormFeedback>
					</Col>
				</Row>
				<Row>
					<Col xs="4">
						<Label className="entryPrompt w-100">Address1</Label>
						<Input type="text" name="text" id="guarantorAddress1" className="rounded-lg addressText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorAddress1: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress1 === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress1} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorAddress1') && this.guarantorvalidationFieldState.address1} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorAddress1')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorAddress1')}</FormFeedback>
					</Col>
					<Col xs="4">
						<Label className="entryPrompt w-100">Address2</Label>
						<Input type="text" name="text" id="guarantorAddress2" className="rounded-lg addressText" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorAddress2: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress2 === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress2} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorAddress2') && this.guarantorvalidationFieldState.address2} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorAddress2')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorAddress2')}</FormFeedback>
					</Col>
				</Row>
				<Row>
					<Col xs="2">
						<Label className="entryPrompt w-75">City</Label>
						<Input type="text" id="guarantorCity" className="rounded-lg w-75" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorCity: e.target.value })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorCity === null ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorCity} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorCity') && this.guarantorvalidationFieldState.city} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorCity')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorCity')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">State</Label>
						<Input type="select" name="gstates" className="rounded-lg w-75 non-uniform" id="gstates" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorStateCodeId: parseInt(e.target.value) })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorStateCodeId === null ? 0 : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorStateCodeId} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorStateCodeId') && this.guarantorvalidationFieldState.state} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorStateCodeId')}>
							{this.props.coverageDiscoveryRequestStateManager.availableStates.map(c => (
								<option key={c.id} value={c.id}>
									{c.name}
								</option>
							))}
						</Input>
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorStateCodeId')}</FormFeedback>
					</Col>
					<Col xs="2">
						<Label className="entryPrompt w-75">ZIP Code</Label>
						<Input type="text" id="guarantorZipCode" className="rounded-lg w-75" placeholder="" onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, guarantorZip: e.target.value.replace(/[^0-9-]/, '') })} value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip === null || typeof this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip === 'undefined' ? '' : this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip.toString()} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorZip') && this.guarantorvalidationFieldState.zip} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.isFieldValid('guarantorZip')} />
						<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedGuarantorDetail.getMessage('guarantorZip')}</FormFeedback>
					</Col>
				</Row>
				<br />
			</Container>
		)
	}

	renderSubscriberGuarantor(): any {
		return (
			<Fragment>
				{this.renderSubscriber()}
				{this.renderGuarantor()}
			</Fragment>
		)
	}

	bindCustomEntityFacilityId(event: any): void {
		const id = parseInt(event.target.value)
		this.props.coverageDiscoveryRequestStateManager.setSelectedRequestDetail({ ...this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail, customerEntityFacilityId: id })
	}

	radioHandler = event => {
		if (event.target.value === '1') {
			this.clearGuarantor()
			this.setState({ IsSubscriberSelected: true, showAgeCheckBox: false }, () => {
				this.calculateConfidenceScore(this.confidenceScoreFieldsState)
			})
			this.isGuarantorSelectedManually = false
		} else {
			this.setState(
				{
					IsSubscriberSelected: false,
					confidenceRating: 1,
					percent: 25,
					color: 'Red',
					confidenceStatus: 'Poor',
				},
				() => {
					this.calculateConfidenceScore(this.guarantorconfidenceScoreFieldsState)
				},
			)
			this.isGuarantorSelectedManually = true
			if (this.IsAgeLessThan26Years(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth)) this.setState({ showAgeCheckBox: true })
		}
	}

	toggleModalForMinFieldsOnly(): any {
		this.setState({
			modalForMinFieldsOnly: !this.state.modalForMinFieldsOnly,
		})
	}

	AreMinFieldsOnlySet(): boolean {
		if (
			(this.state.IsSubscriberSelected &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId != null &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId != 0 &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualFirstName &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualLastName &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId == 0) &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber == '') &&
				(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber == '') &&
				this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualGender == null) ||
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualGender == ''
		) {
			return true
		} else if (
			!this.state.IsSubscriberSelected &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId != null &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId != 0 &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualFirstName &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualLastName &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualDateOfBirth &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualMiddleName == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress1 == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualAddress2 == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualCity == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualStateCodeId == 0) &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualZip == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualSocialSecurityNumber == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualPhoneNumber == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualGender == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.individualGender == '') &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorFirstName &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorLastName &&
			this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorDateOfBirth &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorMiddleName == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorMiddleName == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress1 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress1 == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress2 == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorAddress2 == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorCity == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorCity == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorStateCodeId == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorStateCodeId == 0) &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorZip == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorSocialSecurityNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorSocialSecurityNumber == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorPhoneNumber == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorPhoneNumber == '') &&
			(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorGender == null || this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.guarantorGender == '')
		) {
			return true
		} else return false
	}

	render(): React.ReactNode {
		if (this.state.IsPageLoading) {
			return (
				<div>
					<TopPart pagesource="request" />
					<div className="row  tab-content">
						<div className="spinnerPage">
							<Spinner animation="border" role="status" />
						</div>
					</div>
				</div>
			)
		} else if (!this.state.IsAnyFacilityExist) {
			return (
				<div>
					<TopPart pagesource="request" />
					<div className="row  tab-content">
						<div className="width100P">
							<div className="contentBody">
								<div className="text-danger">Your account must have at least one facility to use the application. Please contact an account administrator to have a facility added.</div>
							</div>
						</div>
					</div>
				</div>
			)
		} else {
			return (
				<div>
					<TopPart pagesource="request" />
					<div className="row  tab-content">
						<div className="width100P">
							<div className="contentBody">
								<Modal modalClassName="mdlForExportRequest" isOpen={this.state.modalForMinFieldsOnly} fade={!this.state.modalForMinFieldsOnly} toggle={(): void => this.toggleModalForMinFieldsOnly()} id="modalForMinFieldsOnly">
									<ModalBody>
										<Form>
											<Row>You have entered only first name, last name and date of birth. We advise entering one or more additional fields to improve the chances of locating coverage. Are you sure you want to submit this request with the current, limited data?</Row>
										</Form>
									</ModalBody>
									<ModalFooter>
										<Button
											id="btnSubmitForMinFieldsOnly"
											className="btn cancel"
											color="btnCancelColor"
											style={{ width: '50px' }}
											onClick={e => {
												this.onSave(e), this.toggleModalForMinFieldsOnly()
											}}
										>
											Yes
										</Button>{' '}
										<Button
											id="btnCancelForMinFieldsOnly"
											className="btn save"
											onClick={(): void => {
												this.toggleModalForMinFieldsOnly()
											}}
											color="btnSaveColor"
											style={{ width: '50px' }}
										>
											No
										</Button>
									</ModalFooter>
								</Modal>
								<Form id="requestForm">
									<Container>
										<div className={this.state.showDataCompletionProgressbar ? 'show' : 'hideDateValidation'}>
											<Label className="entryPrompt w-75" style={{ fontWeight: 'normal' }}>
												Data Completion:&nbsp;<span style={{ fontWeight: 'bold' }}>{this.state.confidenceStatus}</span>
											</Label>
											<ProgressBar value={this.state.percent} showValue={false} color={this.state.color}></ProgressBar>
										</div>
										{/* <progress value={0.50} color={this.state.color} /> */}
										{/* <Progress.Line percent={this.state.percent} strokeColor={this.state.color} /> */}
										<Row>
											<Col xs="4" className="height60">
												<Label className="entryPrompt w-75">
													Facility:<span className="red">*</span>
												</Label>
												<Input type="select" id="ddFacilities" name="facilities" className="w-75 non-uniform" value={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.customerEntityFacilityId} onBlur={this.validateFieldsAndsetConfidenceScore} onChange={e => this.bindCustomEntityFacilityId(e)} valid={this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('customerEntityFacilityId')} invalid={!this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.isFieldValid('customerEntityFacilityId') && this.validationFieldState.Facility}>
													{this.props.coverageDiscoveryRequestStateManager.availableFacilities.map(c => (
														<option key={c.id} value={c.id}>
															{c.name}
														</option>
													))}
												</Input>
												<FormFeedback>{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('customerEntityFacilityId')}</FormFeedback>
											</Col>
										</Row>
										<Row>
											<Col xs="2">
												<Label for="dobBegin" className="entryPrompt w-75">
													Service Dates
												</Label>
												<DatePicker onKeyDown={this.closeSbDatePopupOnTab} ref={this.serBeginDateTexboxRef} className={this.state.IsServiceBeginDateValid ? 'dob dobInputValid' : 'dob dobInputInvalid'} placeholderText="mm/dd/yyyy" showYearDropdown showMonthDropdown dropdownMode="select" peekNextMonth useShortMonthInDropdown name="dobBegin" id="dobBegin" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} selected={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceBeginDate ? new Date(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceBeginDate) : null} onChange={e => this.serviceBeginhandleChange(e)} minDate={moment('01/01/2000', 'DD/MM/YYYY')._d} />
												<FormFeedback id="dBeginFeedBack" className={this.state.IsServiceBeginDateValid ? 'hideDateValidation' : 'show'}>
													{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('serviceBeginDate')}
												</FormFeedback>
											</Col>
											<Col xs="2">
												<Label for="dobEnd" className="entryPrompt w-75">
													thru
												</Label>
												<DatePicker onKeyDown={this.closeSeDatePopupOnTab} ref={this.serviceEndDateTexboxRef} className={this.state.IsServiceEndDateValid ? 'dob dobInputValid' : 'dob dobInputInvalid'} placeholderText="mm/dd/yyyy" showYearDropdown showMonthDropdown dropdownMode="select" peekNextMonth useShortMonthInDropdown name="dobEnd" id="dobEnd" customInput={<MaskedInput type="text" mask={[/[01]/, /\d/, '/', /[0-3]/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]} />} selected={this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceEndDate ? new Date(this.props.coverageDiscoveryRequestStateManager.selectedRequestDetail.serviceEndDate) : null} onChange={e => this.serviceEndhandleChange(e)} minDate={moment('01/01/2000', 'DD/MM/YYYY')._d} />
												<FormFeedback id="dEndFeedBack" className={this.state.IsServiceEndDateValid ? 'hideDateValidation' : 'show'}>
													{this.props.coverageDiscoveryRequestStateManager.validateSelectedRequestDetail.getMessage('serviceEndDate')}
												</FormFeedback>
											</Col>
											<Col xs="2" style={{ marginTop: '25px', paddingLeft: '0px' }}>
												<Label for="dobEnd" className="entryPrompt w-75" style={{ marginBottom: '0px', fontSize: 'small' }}>
													Quick Date Pick
												</Label>

												<a className="quick-pick-today" onClick={this.resetDates} style={{ display: 'block', cursor: 'pointer', fontWeight: 'bold', fontSize: 'small' }}>
													<i className="icon-purple-left-arrow"></i>Today
												</a>
											</Col>
										</Row>
										<Row style={{ marginBottom: '0.5em' }}>
											<Col>
												<FormGroup tag="fieldset">
													<FormGroup check>
														<Label check>
															<Input type="radio" name="radio" id="radioSub" onChange={e => this.radioHandler(e)} value="1" checked={this.state.IsSubscriberSelected && true} /> Subscriber Details
														</Label>
													</FormGroup>
													<FormGroup check>
														<Label check>
															<Input type="radio" name="radio" id="radioDep" onChange={e => this.radioHandler(e)} value="2" checked={!this.state.IsSubscriberSelected && true} /> Guarantor Details
														</Label>
													</FormGroup>
												</FormGroup>
											</Col>
										</Row>
									</Container>
									{this.state.IsSubscriberSelected ? this.renderSubscriber() : this.renderSubscriberGuarantor()}
									<div>
										<ValidationMessage showValidationMessage={this.state.showErrorMessage} MessageType={MessageTypes.Error} validationMessage={this.state.errorMessage} toggleAction={this.toggleValidationMessageShow} />
									</div>
									<Container>
										<Row>
											<Col>
												<div className="col text-center">
													{!this.state.isLoading ? (
														<Button color="btnSaveColor" disabled={this.state.showErrorMessage} className="btn save buttonWidth110" onClick={e => this.onSave(e)}>
															Submit
														</Button>
													) : (
														<Button color="btnSaveColor" className="btn save buttonWidth110" disabled>
															{/* <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" /> */}
															Submitting
														</Button>
													)}
													&nbsp;&nbsp;&nbsp;
													<Button color="btnCancelColor" disabled={this.state.isLoading} className="btn cancel buttonWidth110" onClick={() => this.onClear()}>
														Clear
													</Button>
												</div>
											</Col>
										</Row>
									</Container>
								</Form>
								<div style={{ display: this.state.showProgressbar ? 'block' : 'none' }}>
									<ProgressBar value={this.state.timer}></ProgressBar>
									<div className="col text-center">
										<Label>Your request has been submitted. Hang tight, the search will be completed in less than two minutes.</Label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}
export const CoverageDiscoveryRequestConnected = (): any => {
	const coverageDiscoveryRequestStateManager = container.get<ICoverageDiscoveryRequestStateManager>('ICoverageDiscoveryRequestStateManager')
	const userSessionStateManager = container.get<IUserSessionStateManager>('IUserSessionStateManager')
	return <Route path="/CoverageDiscoveryRequest/:id?" render={props => <CoverageDiscoveryRequest {...props} id={props.match.params.id} coverageDiscoveryRequestStateManager={coverageDiscoveryRequestStateManager} usersessionStateManager={userSessionStateManager} />} />
}
